import Keyable from '../../types/keyable';

interface UpdateArray {
  <Type extends Keyable>(array: Type[], item: Type, replace?: boolean): Type[];
}
const update: UpdateArray = (array, item, replace?) => {
  const index = array.findIndex(it => it.key === item.key);
  if (index === -1) {
    const inserted = array.slice();
    inserted.push(item);
    return inserted;
  }
  return array.map(it => {
    if (it.key === item.key) {
      return replace ? { ...item } : { ...it, ...item };
    }
    return it;
  });
};

const remove: UpdateArray = (array, item) => array.filter(it => it.key !== item.key);

export default {
  update,
  remove,
};
